import React from 'react';
import { Carousel } from 'antd';
import config from '../dummy_data/configuration.json';


const CarouselSlider = ({items}) => {
    return (
        <div className="slider">
			{/*<<Carousel autoplay>
		        <div style={{height: 'auto'}}>
		            <img src={require("../img/timg.jpg")} alt="" style={{width: '100%'}} />
		        </div>
		        <div style={{height: 'auto'}}>
		            <img src={require("../img/timg1.jpg")} alt="" style={{width: '100%'}} />
		        </div>
		        <div style={{height: 'auto'}}>
		            <img src={require("../img/timg2.jpg")} alt="" style={{width: '100%'}} />
		        </div>
		    </Carousel>*/}
		    <Carousel autoplay>
		    {
				items.map((item, i) => {
					return(
						<div key={i} style={{height: 'auto'}} >
							<img src={config.rootSite + item.ImageUrl} alt="" style={{width: '100%'}} />
							{/*<div className="slider-item-text">
								<span>{item.Slogan}</span>
							</div>*/}
						</div>
					);
				})
			}
			</Carousel>

		</div>
    );
}

export default CarouselSlider;


// WEBPACK FOOTER //
// ./src/components/Carousel.js